import { useState } from "react";
import type { Category } from "@/mocks/events";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotList from "./components/HotList";
import Channels from "./components/Channels";
import DeepTimeline from "./components/DeepTimeline";
import Columns from "./components/Columns";
import About from "./components/About";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

function scrollToId(href: string) {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Home() {
  const [category, setCategory] = useState<Category>("全部");

  const handleChannelSelect = (name: Category) => {
    setCategory(name);
    scrollToId("#hot");
  };

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotList selected={category} onSelect={setCategory} />
        <Channels onSelect={handleChannelSelect} />
        <DeepTimeline />
        <Columns />
        <About />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}